<div *transloco="let t; read: 'action-item-table'" class="action-item-table__container">
  <span class="action-item-table__title">{{ t('title') }}</span>

  @if (!isLoading) {
    <div class="action-item-table__scroll" [autoPropagation]="true">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        [matSortDisabled]="disabled"
        class="action-item-table__table"
      >
        <ng-container matColumnDef="tag">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ t('tag') }}</th>
          <td mat-cell *matCellDef="let item">{{ item.item_value }}</td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ t('name') }}</th>
          <td mat-cell *matCellDef="let item">{{ item.name }}</td>
        </ng-container>
        <ng-container matColumnDef="due">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ t('due-date') }}</th>
          <td mat-cell *matCellDef="let item">{{ item.due_date | date: 'dd-MM-yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="assignee">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ t('assignee') }}</th>
          <td mat-cell *matCellDef="let item">{{ item.assignee_user_name }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ t('status') }}</th>
          <td mat-cell *matCellDef="let item">{{ item.statusText }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="disabled ? $event.stopPropagation() : onSelect(row)"
          [ngClass]="{ pointer: !disabled, 'action-item-table__selected-row': isSelected(row) }"
        ></tr>
      </table>
    </div>
  }
</div>
